import { GiEntryDoor, GiReceiveMoney } from "react-icons/gi";
import { IoGameControllerOutline, IoLogoWhatsapp } from "react-icons/io5";
import { SiFreepik } from "react-icons/si";
import { TbNotes } from "react-icons/tb";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

const Container = styled.div`
  background: #141524;
  color: white;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 16px;
`;

const Navbar = styled.nav`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 35px;
  background: #1d1d30;
  border-bottom: 1px solid #2d2d3a;
  background-color: rgba(29, 30, 48, 0.98);
  position: sticky;
  top: 0;
  z-index: 1000;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 15px;
  }
`;

const Title = styled.h1`
  color: #00d675;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
`;

const HeroTitle = styled.h2`
  font-size: 50px;
  font-weight: bold;

  @media (max-width: 768px) {
    font-size: 36px;
  }

  @media (max-width: 480px) {
    font-size: 28px;
  }
`;
const HeroSection = styled.section`
  text-align: center;
  margin-top: 64px;
  max-width: 640px;
`;

const SignUpButton = styled.button`
  margin-top: 24px;
  background-color: #01d676;
  color: black;
  padding: 15px 150px;
  border: none;
  border-radius: 5px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background-color: rgb(70, 241, 130);
  }

  @media (max-width: 480px) {
    padding: 12px 80px;
    font-size: 16px;
  }
`;

const CategoriesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 24px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 480px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const Card = styled.div`
  background: #161625;
  padding: 25px;
  border-radius: 12px;
  border: 1px solid #2d2d3a;
  text-align: left;
  width: 400px;

  @media (max-width: 768px) {
    width: 100%;
    padding: 20px;
  }
`;

const Highlight = styled.span`
  color: #00d675;
`;

const CategoriesSection = styled.section`
  margin-top: 64px;
  text-align: center;
`;

const CardTitle = styled.h3`
  font-size: 18px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const CardDescription = styled.p`
  color: #a1a1b0;
  margin-top: 8px;
`;

const CardLink = styled.a`
  display: block;
  color: #00d675;
  margin-top: 12px;
  font-weight: bold;
  cursor: pointer;
  font-size: 16px;
  &:hover {
    text-decoration: underline;
  }
`;

const Button = styled.button`
  padding: 10px 30px;
  border-radius: 2px;
  font-size: 16px;
  cursor: pointer;
  font-weight: 700;
  margin-left: 10px;
  border: none;

  &:first-child {
    background: transparent;
    color: white;
    border: 0.4px solid gray;
    background-color: #252539;
  }

  &:last-child {
    background: #00d675;
    color: black;
  }

  @media (max-width: 480px) {
    padding: 8px 20px;
    font-size: 14px;
  }
`;
const HowItWorksSection = styled.section`
  margin-top: 64px;
  text-align: center;
  max-width: 90%;
`;

const StepsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 32px;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const StepCard = styled.div`
  background: #1a1a2e;
  padding: 20px;
  border-radius: 12px;
  width: 34%;
  text-align: center;

  @media (max-width: 768px) {
    width: 80%;
  }

  @media (max-width: 480px) {
    width: 100%;
  }
`;

const StepImage = styled.img`
  width: 100%;
  border-radius: 8px;
  margin-bottom: 16px;
`;

const StepTitle = styled.h3`
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 8px;
`;

const StepDescription = styled.p`
  font-size: 14px;
  color: #a1a1b0;
  padding-left: 10px;
  padding-right: 10px;
`;

const Footer = styled.footer`
  background-color: #0c0c0c;
  padding: 60px 80px;
  text-align: left;
  width: 100%;
  margin-top: 50px;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const FooterContainer = styled.div`
  max-width: 1200px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
`;

const FooterLeft = styled.div`
  width: 35%;
  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 20px;
    text-align: center;
  }
`;

const FooterRight = styled.div`
  width: 60%;
  display: flex;
  justify-content: space-between;
  @media (max-width: 768px) {
    width: 100%;
    flex-direction: column;
    text-align: center;
  }
`;

const FooterSection = styled.div`
  width: 30%;
  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 20px;
  }
`;

const FooterTitle = styled.h3`
  color: #22c55e;
  margin-bottom: 10px;
  font-size: 18px;
`;

const FooterText = styled.p`
  color: #bbb;
  font-size: 14px;
  line-height: 1.5;
`;

const FooterLinks = styled.ul`
  list-style: none;
  padding: 0;
`;

const FooterLink = styled.a`
  display: inline-block;
  color: #bbb;
  font-size: 14px;
  text-decoration: none;
  margin: 5px 0;
  &:hover {
    color: white;
  }
`;

const FooterBottom = styled.div`
  margin: 30px;
  border-top: 1px solid #222;
  padding: 20px;
  font-size: 12px;
  color: #bbb;
  text-align: center;
  width: 100%;
`;

export default function KamaiClub() {
  const navigate = useNavigate(); // useNavigate Hook

  return (
    <Container>
      <Navbar>
        <Title>KamaiClub.com</Title>
        <div>
          <Button onClick={() => navigate("/login")}>Sign In</Button>
          <Button onClick={() => navigate("/register")}>Sign Up</Button>
        </div>
      </Navbar>

      <HeroSection>
        <HeroTitle>
          Earn money with KamaiClub
          <br /> in the next <Highlight>15 minutes</Highlight>
        </HeroTitle>
        <p style={{ color: "#A1A1B0", marginTop: "16px" }}>
          Weve got an incredible range of money-making opportunities in the form of tasks waiting
          for you.
        </p>
        <p style={{ color: "#A1A1B0", marginTop: "16px" }}>
          See our 160,086 reviews on trustpilot logo
        </p>
        <SignUpButton>Sign Up Now</SignUpButton>
      </HeroSection>
      <CategoriesSection>
        <h2>Categories</h2>
        <p style={{ color: "#A1A1B0", marginTop: "10px", fontSize: "15px" }}>
          Discover the perfect offer tailored just for you. Explore our categories below to find
          offers that match your interests.
        </p>
        <CategoriesGrid>
          <Card>
            <CardTitle>
              <IoGameControllerOutline size={30} color="#00d675" />
              Games
            </CardTitle>
            <CardDescription>Play sought-after games and earn while you do it.</CardDescription>
            <CardLink>Play Games and earn →</CardLink>
          </Card>
          <Card>
            <CardTitle>
              <TbNotes size={30} color="#00d675" /> Surveys
            </CardTitle>
            <CardDescription>Fill out different surveys online to earn cash.</CardDescription>
            <CardLink>Go to Surveys →</CardLink>
          </Card>
          <Card>
            <CardTitle>
              <IoLogoWhatsapp size={30} color="#00d675" /> App
            </CardTitle>
            <CardDescription>Complete simple tasks in apps and earn money.</CardDescription>
            <CardLink>Complete App tasks →</CardLink>
          </Card>
          <Card>
            <CardTitle>
              <GiReceiveMoney size={30} color="#00d675" /> Casino
            </CardTitle>
            <CardDescription>Get lucky with casino offers and win big!</CardDescription>
            <CardLink>Casino Offers →</CardLink>
          </Card>
          <Card>
            <CardTitle>
              <GiEntryDoor size={30} color="#00d675" /> Sign up
            </CardTitle>
            <CardDescription>
              Simply sign up for different products and get rewarded.
            </CardDescription>
            <CardLink>Sign up to win →</CardLink>
          </Card>
          <Card>
            <CardTitle>
              <SiFreepik size={30} color="#00d675" /> Free Trial
            </CardTitle>
            <CardDescription>
              Complete free trial offers and withdraw funds into your account.
            </CardDescription>
            <CardLink>Free trials →</CardLink>
          </Card>
        </CategoriesGrid>
      </CategoriesSection>
      <HowItWorksSection>
        <h2 style={{ fontSize: "24px", fontWeight: "bold" }}>How it works</h2>
        <p style={{ color: "#A1A1B0" }}>
          Youre just three easy steps away from getting your favorite gift cards!
        </p>
        <StepsContainer>
          <StepCard>
            <StepImage
              src="https://cdn.prod.website-files.com/61dfc899a471632619dca9dd/66562b1aefef8f1db4fbc7ef_Screenshot%202024-05-28%20at%209.05.53%20PM.png"
              alt="Step 1"
            />
            <StepTitle>1. Select an offer</StepTitle>
            <StepDescription>
              Explore our earn page and choose from our wide variety of offers to complete.
            </StepDescription>
          </StepCard>
          <StepCard>
            <StepImage src="https://cdn.prod.website-files.com/61dfc899a471632619dca9dd/66562b1aefef8f1db4fbc7ef_Screenshot%202024-05-28%20at%209.05.53%20PM.png" />
            <StepTitle>2. Earn KamaiClub coins</StepTitle>
            <StepDescription>
              Watch videos, play games, fill out surveys, or download apps to earn coins.
            </StepDescription>
          </StepCard>
          <StepCard>
            <StepImage src="https://cdn.prod.website-files.com/61dfc899a471632619dca9dd/66562b1aefef8f1db4fbc7ef_Screenshot%202024-05-28%20at%209.05.53%20PM.png" />
            <StepTitle>3. Get rewarded</StepTitle>
            <StepDescription>
              Once you reach the withdrawal threshold, choose your reward on the Cashout page.
            </StepDescription>
          </StepCard>
        </StepsContainer>
      </HowItWorksSection>

      <Footer>
        <FooterContainer>
          <FooterLeft>
            <FooterTitle>KamaiClub</FooterTitle>
            <FooterText>
              KamaiClub is a platform where users can earn money and rewards by completing tasks,
              surveys, and offers.
            </FooterText>
          </FooterLeft>
          <FooterRight>
            <FooterSection>
              <FooterTitle>KamaiClub</FooterTitle>
              <FooterLinks>
                <li>
                  <FooterLink href="#">Earn</FooterLink>
                </li>
                <li>
                  <FooterLink href="#">Cashout</FooterLink>
                </li>
                <li>
                  <FooterLink href="#">How to earn?</FooterLink>
                </li>
              </FooterLinks>
            </FooterSection>
            <FooterSection>
              <FooterTitle>Resources</FooterTitle>
              <FooterLinks>
                <li>
                  <FooterLink href="#">Live Support</FooterLink>
                </li>
                <li>
                  <FooterLink href="#">Academy</FooterLink>
                </li>
                <li>
                  <FooterLink href="#">Help Center</FooterLink>
                </li>
              </FooterLinks>
            </FooterSection>
            <FooterSection>
              <FooterTitle>Business</FooterTitle>
              <FooterLinks>
                <li>
                  <FooterLink href="#">Contact</FooterLink>
                </li>
                <li>
                  <FooterLink href="#">Affiliates</FooterLink>
                </li>
                <li>
                  <FooterLink href="#">Advertise with us</FooterLink>
                </li>
              </FooterLinks>
            </FooterSection>
          </FooterRight>
        </FooterContainer>
        <FooterBottom>
          <p>
            &copy; KamaiClub 2025 &bull; <FooterLink href="#">Terms of Service</FooterLink> &bull;
            <FooterLink href="#"> Privacy Policy</FooterLink> &bull;
            <FooterLink href="#"> Cookie Policy</FooterLink>
          </p>
        </FooterBottom>
      </Footer>
    </Container>
  );
}
